import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import Modal from '../../components/common/Modal';
import { useApi } from '../../hooks/useApi';
import { getLedgerEdits } from '../../lib/api/ledger';

export default function EntryHistoryModal({ entry, onClose }) {
  const { execute, loading } = useApi(getLedgerEdits);
  const [edits, setEdits] = useState([]);

  useEffect(() => {
    execute(entry.id).then(setEdits).catch(() => {});
  }, []);

  return (
    <Modal title="Version History" onClose={onClose}>
      <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
        <div className="border-l-2 border-indigo-500 pl-4 py-1 relative">
          <div className="absolute w-3 h-3 bg-indigo-500 rounded-full -left-[7px] top-2"></div>
          <p className="text-xs font-bold text-indigo-600 uppercase mb-1">Current State</p>
          <p className="font-bold text-gray-900">${entry.amount.toFixed(2)}</p>
          <p className="text-sm text-gray-600">{entry.note || 'No note'}</p>
        </div>

        {loading ? <p className="text-sm text-gray-500">Loading history...</p> : 
         edits.length === 0 ? <p className="text-sm text-gray-500 italic">No edits have been made to this entry.</p> :
         edits.map((edit, idx) => (
          <div key={edit.id} className="border-l-2 border-gray-200 pl-4 py-1 relative opacity-70">
            <div className="absolute w-3 h-3 bg-gray-300 rounded-full -left-[7px] top-2"></div>
            <p className="text-xs font-bold text-gray-500 uppercase mb-1">
              Previous Version • {format(new Date(edit.edited_at), 'MMM d, h:mm a')}
            </p>
            <p className="font-bold text-gray-700">${edit.old_amount.toFixed(2)}</p>
            <p className="text-sm text-gray-600">{edit.old_note || 'No note'}</p>
          </div>
        ))}
      </div>
    </Modal>
  );
}